import classNames from 'classnames'

import { Avatar, Body } from '@foxino/components-web'

import { authStore } from '@app/app/auth/store/authStore'
import { useTestId } from '@app/hooks/useTestId'
import { dialogStateStore } from '@app/modules/learningPlan/store/dialogStateStore'

type Props = {
  isExpanded: boolean
}

export const UserInfo = ({ isExpanded }: Props) => {
  const testId = useTestId(['side_navigation'])

  const { fullName, email } = authStore.useStore((store) => store.userInfo)

  const handleOnClick = () => {
    dialogStateStore.setIsOpen('settings')
  }

  return (
    <div
      className={classNames(
        'flex size-full cursor-pointer flex-row items-center gap-4 rounded-md p-3 transition-opacity',
        !isExpanded ? 'justify-center' : 'justify-start'
      )}
      onClick={handleOnClick}
      data-testid={testId('settings')}
    >
      <Avatar fullName={fullName} showTooltip={!isExpanded} size="m" className="cursor-pointer" side="right" />
      {isExpanded && (
        <div className="flex flex-col items-start">
          <Body size="md" weight="regular" className="text-neutral-300">
            {fullName}
          </Body>
          <Body size="sm" weight="regular" className="text-neutral-100">
            {email}
          </Body>
        </div>
      )}
    </div>
  )
}
